import { v4 as uuidv4 } from 'uuid';
import modelBaseV2 from "../model-base-v2.model";

/**
 * Raw Data Model
 * 
 * Model for all Raw Data related APIs.
 * 
 * @author Darrus Goh
 */
const RawDataModel = {
    // COMMON FUNCTIONS
    getDataTypes: (type) => {
        return modelBaseV2.get('/api/rawdata/datatype', { params: { type } });
    },

    getConfigs: (dataTypeId) => {
        return modelBaseV2.get('/api/rawdata/config/:dataTypeId', { params: { dataTypeId } });
    },

    getFilters: (dataTypeId, location = '') => {
        return modelBaseV2.get(`/api${location}/rawdata/filter/:dataTypeId`, { params: { dataTypeId } });
    },

    // RAW DATA DOWNLOAD FUNCTIONS
    downloadRawDataDownloadData: (dataTypeId, body, location = '', filename = `${uuidv4()}.xlsx`) => {
        return modelBaseV2.postDownload(`/api${location}/rawdata/download/:dataTypeId`, { params: { dataTypeId }, body }, filename);
    },

    // RAW DATA DELETE FUNCTIONS
    downloadRawDataDeleteData: (dataTypeId, body, location = '', filename = `${uuidv4()}.xlsx`) => {
        return modelBaseV2.postDownload(`/api${location}/rawdata/delete/data/:dataTypeId`, { params: { dataTypeId }, body }, filename);
    },

    deleteAndDownloadRawDataDeleteData: (dataTypeId, body, location = '', filename = `${uuidv4()}.xlsx`) => {
        return modelBaseV2.postDownload(`/api${location}/rawdata/delete/:dataTypeId`, { params: { dataTypeId }, body }, filename);
    },
 
    // RAW DATA UPLOAD FUNCTIONS
    downloadUploadTemplate: (dataTypeId, filename = `${uuidv4()}.xlsx`) => {
        return modelBaseV2.getDownload('/api/rawdata/upload/template/:dataTypeId', { params: { dataTypeId } }, filename);
    },

    getRawDataUploads: (dataTypeId, fromDate, toDate, location = '') => {
        return modelBaseV2.get(`/api${location}/rawdata/upload/:dataTypeId`, { params: { dataTypeId, fromDate, toDate } });
    },

    downloadRawDataUploadResultType: (headerId, type, filename = `${uuidv4()}.xlsx`, location = '') => {
        return modelBaseV2.postDownload(`/api${location}/rawdata/upload/:headerId/result`, { params: { headerId, type } }, filename);
    },

    downloadRawDataUploadData: (dataTypeId, body, location = '', filename = `${uuidv4()}.xlsx`) => {
        return modelBaseV2.postDownload(`/api${location}/rawdata/upload/data/:dataTypeId`, { params: { dataTypeId }, body }, filename);
    },

    uploadRawDataUpload: (dataTypeId, formData, location = '') => {
        return modelBaseV2.post(`/api${location}/rawdata/upload/:dataTypeId`, { params: { dataTypeId }, body: formData });
    },

    getRawDataTemplateList: (dataType) => {
        return modelBaseV2.get('/api/user/rawdata/templates', { params: { dataType } });
    },

    saveRawDataAccess: (body) => {
        return modelBaseV2.post('/api/user/rawdata/add/access', { body });
    },

    getRawDataAccessList: (params) => {
        let qs = modelBaseV2.toQueryString(params)
        return modelBaseV2.get(`/api/user/rawdata/get/access?${qs}`)
    },
    deleteRawDataAccess: (body) => {
        return modelBaseV2.post('/api/user/rawdata/delete/access', { body })
    }
};

export default RawDataModel;